var _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01VideoSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.14 13.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 1.63 0 1.63 0 1.63 0 1.63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401.26,183.45c0,.18,0,.36,0,.54v1.24c0,.27,0,.54,0,.8v4.91c0,.14,0,.29,0,.43,0,.31,0,.64,0,.95a2,2,0,0,0,.23.87,1.83,1.83,0,0,0,.34.47,1.93,1.93,0,0,0,1.39.54c3.62,0,4.52,0,8.17,0a1.9,1.9,0,0,0,2-2v-1.51c0-.05,0-.09,0-.15l0-.25.24.09.15,0,1.95.78,3.74,1.5a.63.63,0,0,0,.6,0,.65.65,0,0,0,.23-.57v-9.45a.64.64,0,0,0-.23-.56.63.63,0,0,0-.6,0l-5.69,2.28-.16,0-.26.09v-.74c0-.4,0-.78,0-1.17a1.9,1.9,0,0,0-2-2c-3.41,0-4.35,0-7.47,0h-.7a2.12,2.12,0,0,0-1,.25,1.92,1.92,0,0,0-.94,1.39h-.13l.13,0A5.25,5.25,0,0,0,401.26,183.45Zm12.11,2.72V186a.34.34,0,0,1,.22-.37l4.09-1.63,1.27-.51.1,0,.21-.07v8.14l-2.38-1-3.24-1.29a.39.39,0,0,1-.27-.4C413.38,188,413.37,187.07,413.37,186.17Zm-11.05-3.44a.88.88,0,0,1,1-1h8c.71,0,1,.31,1,1v9.38c0,.71-.31,1-1,1h-8a.9.9,0,0,1-1-1Z",
    transform: "translate(-401.17 -180.67)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01VideoSelect);
export default __webpack_public_path__ + "static/media/01_Video_Select.9089548a2fc24e83ecd00f3a571bff68.svg";
export { ForwardRef as ReactComponent };